var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVirtualTerminalDonation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1352_10775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.19531 7.22168L10.6641 11.9092C10.7959 12.0557 10.9375 12.2705 10.9375 12.5C10.9375 12.7295 10.7959 12.9443 10.6641 13.0908L5.19531 17.7783C4.86816 18.0615 4.375 18.0225 4.09424 17.6953C3.81348 17.3682 3.85156 16.875 4.1792 16.5967L8.95508 12.5L4.1792 8.40332C3.85156 8.125 3.81348 7.63184 4.09424 7.30469C4.375 6.97754 4.86816 6.93848 5.19531 7.22168ZM17.9688 17.1875C18.3984 17.1875 18.75 17.5391 18.75 17.9688C18.75 18.3984 18.3984 18.75 17.9688 18.75H10.1562C9.72656 18.75 9.375 18.3984 9.375 17.9688C9.375 17.5391 9.72656 17.1875 10.1562 17.1875H17.9688ZM18.75 1.5625C20.4736 1.5625 21.875 2.96143 21.875 4.6875V20.3125C21.875 22.0361 20.4736 23.4375 18.75 23.4375H3.125C1.39893 23.4375 0 22.0361 0 20.3125V4.6875C0 2.96143 1.39893 1.5625 3.125 1.5625H18.75ZM18.75 3.125H3.125C2.26221 3.125 1.5625 3.82471 1.5625 4.6875V20.3125C1.5625 21.1768 2.26221 21.875 3.125 21.875H18.75C19.6143 21.875 20.3125 21.1768 20.3125 20.3125V4.6875C20.3125 3.82471 19.6143 3.125 18.75 3.125Z",
    fill: "#61A578"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1352_10775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.875,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualTerminalDonation);
export default __webpack_public_path__ + "static/media/virtual_terminal_donation_.aa23febf42ee8de0ca2ad4a836727abc.svg";
export { ForwardRef as ReactComponent };